import countries from 'i18n-iso-countries';
import enCountries from 'i18n-iso-countries/langs/en.json';
import ukCountries from 'i18n-iso-countries/langs/uk.json';

try {
  countries.registerLocale(enCountries);
  countries.registerLocale(ukCountries);
} catch (_) {}

export const LANG_TO_FLAG_ALPHA2 = {
  ua: 'ua',
  en: 'gb',
  fr: 'fr',
  de: 'de',
  it: 'it',
  es: 'es',
  pt: 'pt',
  pl: 'pl',
  cs: 'cz',
  sk: 'sk',
  hu: 'hu',
  ro: 'ro',
  ru: 'ru',
  bg: 'bg',
  sr: 'rs',
  hr: 'hr',
  mk: 'mk',
  sq: 'al',
  sl: 'si',
  el: 'gr',
  tr: 'tr',
  nl: 'nl',
  ka: 'ge',
  hy: 'am',
  is: 'is',
  fi: 'fi',
  sv: 'se',
  da: 'dk',
  no: 'no',
  et: 'ee',
  lt: 'lt',
  lv: 'lv',
  ca: 'ad'
};

export const normalizeLocaleForCountries = (loc) => (loc === 'ua' ? 'uk' : loc);

export const getCountryFlagAlpha2 = (country) => {
  if (!country) return 'un';

  const nameMap = country.name || {};
  if (nameMap && typeof nameMap === 'object') {
    const preferredLocales = ['en', 'uk'];
    const providedLocales = Object.keys(nameMap).map(normalizeLocaleForCountries).filter(Boolean);
    const localesToTry = Array.from(new Set([...preferredLocales, ...providedLocales]));

    for (const loc of localesToTry) {
      const displayName = nameMap[loc === 'uk' ? 'ua' : loc] || nameMap[loc];
      if (!displayName) continue;
      const code = countries.getAlpha2Code(displayName, loc);
      if (code) return String(code).toLowerCase();
    }
  }

  const lng = (country.language && country.language[0]) || '';
  return LANG_TO_FLAG_ALPHA2[lng] || 'un';
};

export const localeToFlagAlpha2 = (locale) => LANG_TO_FLAG_ALPHA2[locale] || 'un';

// Reverse mapping: country code to locale
// This maps ISO 3166-1 alpha-2 country codes to supported locales
export const COUNTRY_TO_LOCALE = {
  // Ukraine
  ua: 'ua',
  // United Kingdom
  gb: 'en',
  // France
  fr: 'fr',
  // Germany
  de: 'de',
  // Italy
  it: 'it',
  // Spain
  es: 'es',
  // Portugal
  pt: 'pt',
  // Poland
  pl: 'pl',
  // Czech Republic
  cz: 'cs',
  // Slovakia
  sk: 'sk',
  // Hungary
  hu: 'hu',
  // Romania
  ro: 'ro',
  // Russia
  ru: 'ru',
  // Bulgaria
  bg: 'bg',
  // Serbia
  rs: 'sr',
  // Croatia
  hr: 'hr',
  // North Macedonia
  mk: 'mk',
  // Albania
  al: 'sq',
  // Slovenia
  si: 'sl',
  // Greece
  gr: 'el',
  // Turkey
  tr: 'tr',
  // Netherlands
  nl: 'nl',
  // Georgia
  ge: 'ka',
  // Armenia
  am: 'hy',
  // Iceland
  is: 'is',
  // Finland
  fi: 'fi',
  // Sweden
  se: 'sv',
  // Denmark
  dk: 'da',
  // Norway
  no: 'no',
  // Estonia
  ee: 'et',
  // Lithuania
  lt: 'lt',
  // Latvia
  lv: 'lv',
  // Andorra
  ad: 'ca',
  // Additional English-speaking countries default to English
  us: 'en',
  ca: 'en',
  au: 'en',
  nz: 'en',
  ie: 'en',
  // Additional Spanish-speaking countries
  mx: 'es',
  ar: 'es',
  co: 'es',
  cl: 'es',
  pe: 'es',
  ve: 'es',
  // Additional Portuguese-speaking countries
  br: 'pt',
  // Additional French-speaking countries
  be: 'fr',
  // Additional German-speaking countries
  at: 'de',
  // Switzerland (default to German)
  ch: 'de',
  // Additional countries with supported languages
  ba: 'sr', // Bosnia and Herzegovina
  me: 'sr', // Montenegro
  xk: 'sq', // Kosovo
};

// Get locale from country code, with fallback to 'en'
export const countryToLocale = (countryCode) => {
  if (!countryCode) return 'en';
  const code = countryCode.toLowerCase();
  return COUNTRY_TO_LOCALE[code] || 'en';
};
